export default "__VITE_ASSET__3WGoSFv___"